export class MensajeSoporte {
    asunto : string;
    mensaje : string;
    imagen  : string;
    url  : string;
    esUnMensajeDeError: boolean;
}
